import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ShiftCMSState } from '@/store';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentMenu',
  setup(__props) {

const store = useStore<ShiftCMSState>();
const route = useRoute();
const router = useRouter();

const token = computed(() => store.state.token);

function showContent() {
  router.push('/content');
}
function showSchedules() {
  router.push('/content/schedule');
}
function showDiscounts() {
  router.push('/content/discounts');
}
function exportContacts() {
  window.open(`/api/contact-csv?token=${token.value}`, 'new');
}

function getPage(path: string): string {
  switch (path) {
    case '/content':
      return 'List';
    case '/content/schedule':
      return 'Schedule';
    case '/content/discounts':
      return 'Discounts';
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { app: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_breadcrumbs, {
        items: ['Content', getPage(_unref(route).path)]
      }, null, 8, ["items"]),
      (_unref(route).path !== '/content/schedule')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            flat: "",
            color: "info",
            onClick: showSchedules
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Schedule")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).path !== '/content')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            flat: "",
            color: "info",
            onClick: showContent
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("List")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).path !== '/content/discounts')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            flat: "",
            color: "info",
            onClick: showDiscounts
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Discounts")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_btn, {
        flat: "",
        color: "info",
        onClick: exportContacts
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Export contacts")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})